var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OutlineFilter } from "@pixi/filter-outline";
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { IdTooltipsDelay } from "../../constants/IdTooltipsDelay";
import { IdTooltipType } from "../../constants/IdTooltipType";
import { mapOutskirtCalloutOffset } from "../../constants/mapOutskirtCalloutOffset";
import { mapOutskirtsCallout } from "../../constants/mapOutskirtsCallout";
import { mapOutskirtsOnClick } from "../../constants/mapOutskirtsOnClick";
import { mapOutskirtsQualifiers } from "../../constants/mapOutskirtsQualifiers";
import { mapOutskirtTooltipOffset } from "../../constants/mapOutskirtTooltipOffset";
import { eventsCanvas } from "../../events/eventsCanvas";
import { IdCursor } from "../../events/IdCursor";
import { GetOutskirtBuildingGraphic } from "../../graphics/outskirts/GetOutskirtBuildingGraphic";
import { StateBuildingGraphics } from "../../graphics/StateBuildingGraphics";
import { selectThemedEventBuildingName } from "../../selectors/selectEventInfo";
import { selectIsGridVisible } from "../../selectors/selectExistingBuildingInfo";
import { selectOutskirtBuildingInfo } from "../../selectors/selectOutskirtBuildingInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { shallowDiffers } from "../../utils/shallowDiffers";
import { IdEventSoundCore } from "../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../utils/sound/utilSound";
import { bugsnagClient } from "../bugsnag/bugsnagClient";
import { CanvasConnectedComponent } from "../generic/CanvasConnectedComponent";
import { IdAssetBundleCore } from "../loading/IdAssetBundleCore";
import { actionNotToBeImplemented } from "../not-yet-implemented/actionNotYetImplemented";
import { actionBuildingsDeselect } from "../player-base/buildings/actionBuildings";
import { actionTooltipHideBuildingText, actionTooltipShowBuildingText, } from "../tooltip/actionTooltip";
var OutskirtBuilding = /** @class */ (function (_super) {
    __extends(OutskirtBuilding, _super);
    function OutskirtBuilding(id) {
        var _this = _super.call(this) || this;
        _this.shouldUpdate = function (props, prevProps) {
            if (!props.areAssetsLoaded) {
                return false;
            }
            return (!prevProps ||
                shallowDiffers(props.data, prevProps.data) ||
                prevProps.areAssetsLoaded !== props.areAssetsLoaded ||
                prevProps.isAccessible !== props.isAccessible);
        };
        // If your code just broke because of this function, odds are you are using this class
        // instead of implementing your outskirt building. Please implement an outskirt building
        // which extends this class instead of using this class directly.
        _this.mapState = function (state) { return _this.baseMapState(state); };
        // check previous comment.
        _this.mapDispatch = function (dispatch) { return _this.baseMapDispatch(dispatch); };
        // check previous comment.
        _this.update = function (props) { return _this.baseUpdate(props, undefined, true); };
        _this.baseUpdate = function (props, buildingGraphicsState, isImplemented, shouldRenderCallout) {
            if (buildingGraphicsState === void 0) { buildingGraphicsState = StateBuildingGraphics.Idle; }
            if (isImplemented === void 0) { isImplemented = true; }
            if (shouldRenderCallout === void 0) { shouldRenderCallout = false; }
            _this.onMouseOverDispatch = props.onMouseOverDispatch;
            _this.onMouseOutDispatch = props.onMouseOutDispatch;
            _this.isImplemented = isImplemented;
            if (!isImplemented) {
                _this.loca = IdLoca.floatingText_featureNotAvailableYet;
            }
            else if (props.isAccessible) {
                _this.loca = props.data.balancing.locaKey;
            }
            else {
                _this.loca = IdLoca.floatingText_levelCap;
                _this.replacements = new Map([
                    [ReplacementLoca.zero_0, props.data.balancing.unlockLevel.toString()],
                ]);
            }
            _this.updateDisplay(props, buildingGraphicsState, shouldRenderCallout);
        };
        _this.assignMouseOverSubs = function () {
            _this.mouseOverSub$ = eventsCanvas
                .createMouseOver$(_this)
                .subscribe(function () { return _this.onMouseOver(_this); });
            _this.mouseOutSub$ = eventsCanvas
                .createMouseOut$(_this)
                .subscribe(function () { return _this.onMouseOut(_this); });
        };
        _this.assignClickSub = function (props, force) {
            if (force === void 0) { force = false; }
            if (_this.clickSub$ != undefined && (!props.isAccessible || force)) {
                _this.clickSub$.unsubscribe();
                _this.clickSub$ = undefined;
            }
            if (props.isAccessible && _this.clickSub$ === undefined) {
                _this.clickSub$ = eventsCanvas.createClick$(_this).subscribe(function () {
                    utilSound.event(IdEventSoundCore.ButtonClick);
                    props.onClick();
                });
            }
        };
        _this.baseMapState = function (state) {
            var outskirtsBundle = state.loading.bundles[IdAssetBundleCore.Outskirts];
            var qualifier = mapOutskirtsQualifiers.has(_this.outskirtId)
                ? mapOutskirtsQualifiers.get(_this.outskirtId)
                : function (s) { return false; };
            return {
                areAssetsLoaded: outskirtsBundle && outskirtsBundle.isLoaded,
                buildingName: selectThemedEventBuildingName(state),
                data: selectOutskirtBuildingInfo(state, _this.id),
                getGraphics: GetOutskirtBuildingGraphic,
                isAccessible: qualifier(state) && !selectIsGridVisible(state),
            };
        };
        _this.baseMapDispatch = function (dispatch) {
            var onClickAction = mapOutskirtsOnClick.has(_this.outskirtId)
                ? mapOutskirtsOnClick.get(_this.outskirtId)
                : actionNotToBeImplemented();
            var tooltipId = IdTooltipType.Outskirt + _this.outskirtId;
            return {
                onClick: function () {
                    bugsnagClient.bugsnag.leaveBreadcrumb("Outskirt Building click", {
                        name: IdOutskirtBuildings[_this.outskirtId],
                    });
                    dispatch(actionTooltipHideBuildingText(tooltipId));
                    dispatch(actionBuildingsDeselect());
                    return dispatch(onClickAction);
                },
                onMouseOutDispatch: function () { return dispatch(actionTooltipHideBuildingText(tooltipId)); },
                onMouseOverDispatch: function (position, loca, stage, replacements) {
                    return dispatch(actionTooltipShowBuildingText(tooltipId, position, loca, stage, replacements));
                },
            };
        };
        _this.onMouseOver = function (currentOutskirtBuilding) {
            if (_this.props.isAccessible && _this.isImplemented) {
                _this.filters = [OutskirtBuilding.OutlineFilter];
            }
            var position = currentOutskirtBuilding.position;
            var offset = mapOutskirtTooltipOffset.has(currentOutskirtBuilding.id)
                ? mapOutskirtTooltipOffset.get(currentOutskirtBuilding.id)
                : new PIXI.Point(0, 0);
            if (!_this.dispatched) {
                clearTimeout(_this.mouseOverSubTimer);
                _this.mouseOverSubTimer = setTimeout(function () {
                    _this.dispatched = true;
                    currentOutskirtBuilding.onMouseOverDispatch(new PIXI.Point(position.x + offset.x, position.y + offset.y), _this.loca, _this.stage, _this.replacements);
                }, IdTooltipsDelay.standardDelay);
            }
        };
        _this.onMouseOut = function (currentOutskirtBuilding) {
            _this.filters = [];
            clearTimeout(_this.mouseOverSubTimer);
            if (_this.dispatched) {
                _this.dispatched = false;
                currentOutskirtBuilding.onMouseOutDispatch();
            }
        };
        _this.updateDisplay = _this.updateDisplay.bind(_this);
        _this.outskirtId = id;
        _this.interactive = true;
        _this.cursor = IdCursor.Pointer;
        _this.isImplemented = false;
        _this.replacements = new Map();
        // tslint:disable:no-empty
        _this.onMouseOverDispatch = function (position, loca) { };
        _this.onMouseOutDispatch = function () { };
        // tslint:enable:no-empty
        _this.assignMouseOverSubs();
        return _this;
    }
    OutskirtBuilding.prototype.updateDisplay = function (props, buildingGraphicsState, shouldRenderCallout) {
        if (buildingGraphicsState === void 0) { buildingGraphicsState = StateBuildingGraphics.Idle; }
        if (shouldRenderCallout === void 0) { shouldRenderCallout = false; }
        if (this.display) {
            this.cleanupChild(this.display);
        }
        if (this.displayCallout) {
            this.cleanupChild(this.displayCallout);
        }
        this.display = props.getGraphics(props.data, buildingGraphicsState, true, // we always draw the collider in order to be able to display tooltip messages.
        props.buildingName);
        if (this.display != undefined) {
            if (shouldRenderCallout) {
                if (mapOutskirtsCallout.has(this.outskirtId)) {
                    var calloutDisplayHandler = mapOutskirtsCallout.get(this.outskirtId);
                    if (calloutDisplayHandler !== undefined) {
                        this.displayCallout = calloutDisplayHandler();
                    }
                }
            }
            this.addChild(this.display);
            this.assignClickSub(props);
            if (this.displayCallout !== undefined && shouldRenderCallout) {
                var offset = mapOutskirtCalloutOffset.has(this.outskirtId)
                    ? mapOutskirtCalloutOffset.get(this.outskirtId)
                    : new PIXI.Point(0, 0);
                this.displayCallout.position.set(offset.x, offset.y);
                this.addChild(this.displayCallout);
            }
        }
    };
    OutskirtBuilding.OutlineFilter = new OutlineFilter(2, 0xffffff);
    return OutskirtBuilding;
}(CanvasConnectedComponent));
export { OutskirtBuilding };



//////////////////
// WEBPACK FOOTER
// ./src/features/outskirts/OutskirtBuilding.ts
// module id = 221
// module chunks = 3